import React, { FC } from 'react';
import { useField, FieldAttributes } from 'formik';
import { Text, Checkbox, Box as Wrapper } from '@tonic-ui/react';
import { InlineError } from '../../components/forms';
import { useTranslation, Trans } from 'react-i18next';
import ExternalLink from '../../components/external-link/external-link';

type TcCheckboxProps = {
  variantColor?: string;
  size?: string;
  countryId: string;
} & FieldAttributes<Record<string, unknown>>;

const TCCheckbox: FC<TcCheckboxProps> = ({
  variantColor = 'blue',
  size = 'md',
  countryId,
  ...rest
}) => {
  const [field, meta] = useField<Record<string, unknown>>(rest);
  const isInvalid = meta.error && meta.touched ? meta.error : '';
  const {
    t,
    i18n: { language },
  } = useTranslation();

  let termsAndConditionsLink =
    'https://www.trendmicro.com/en_us/about/legal.html?modal=en-english-cloud-services-terms-of-servicepdf#t4';
  let privacyNoticeLink =
    'https://www.trendmicro.com/en_ca/about/legal/privacy.html?modal=en-english-global-privacy-noticepdf';
  let dataCollectionDisclosureLink =
    'https://success.trendmicro.com/data-collection-disclosure#CloudOne';

  if (countryId === 'JP') {
    termsAndConditionsLink = 'https://www.trendmicro.com/ja_jp/about/legal/eula.html';
    privacyNoticeLink =
      'https://www.trendmicro.com/en_ca/about/legal/privacy.html?modal=jp-japanese-global-privacy-noticepdf';
    dataCollectionDisclosureLink =
      'https://success.trendmicro.com/data-collection-disclosure#CloudOne';
  }

  return (
    <>
      <Checkbox
        {...field}
        checked={field.value}
        variantColor={isInvalid ? 'red' : variantColor}
        size={size}
      >
        <Wrapper>
          <Trans
            i18nKey={`termsAndConditions.termsAndConditionsLabel`}
            components={{
              termsLink: <ExternalLink href={termsAndConditionsLink} showIcon={false} />,
            }}
          />
          <Trans
            i18nKey={`termsAndConditions.privacyNoticeLabel`}
            components={{
              privacyLink: <ExternalLink href={privacyNoticeLink} showIcon={false} />,
            }}
          />
          <Trans
            i18nKey={`termsAndConditions.dataCollectionDisclosureLabel`}
            components={{
              dataCollectLink: (
                <ExternalLink href={dataCollectionDisclosureLink} showIcon={false} />
              ),
            }}
          />
        </Wrapper>
      </Checkbox>
      {isInvalid && (
        <Text size="xs" mt="1x">
          <InlineError errorName={isInvalid} />
        </Text>
      )}
    </>
  );
};

export default TCCheckbox;
